import { Box } from '@mui/material';
import DOMPurify from 'dompurify';
import React from 'react';
import ChatBotLoader from './ChatbotLoader';
DOMPurify.addHook('afterSanitizeAttributes', function (node) {
    // set all elements owning target to target=_blank
    if ('target' in node) {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener noreferrer');
    }
});
const BotChatMessage = ({ message }) => {
    return (React.createElement(Box, { className: "chatbot-answer", "data-cy": "chatBotAnswer" }, !message ? (React.createElement(ChatBotLoader, null)) : (React.createElement("div", { dangerouslySetInnerHTML: {
            __html: DOMPurify.sanitize(`<p>${message}</p>`),
        } }))));
};
export default BotChatMessage;
